import React, { useState, useEffect } from 'react';
import Header from '../component/header';
import { useNavigate } from 'react-router-dom';
import "../assets/css/property.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function PropertyDetail() {
    const navigate = useNavigate();
    const [usersData, setUsersData] = useState(null);
    const [projectDetails, setProjectDetails] = useState(null);
    const config = configModule.config();

    const getPropertiesData = async () => {

        try {
            const response = await axios.get(
                `${config.apiBaseUrl}/get-invprojects/${usersData?.id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const card = response.data;
            setProjectDetails(card);

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    useEffect(() => {
        if (usersData?.id) {
            getPropertiesData();
        }
    }, [usersData]);

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    return (
        <div className='dashboardmain-st'>
            <Header pageName="Property Details" />
            <div className="body-dashboard">
                <div className="page-header">
                    <div className="back-btn" onClick={() => navigate("/portfolio")}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="#c9a84c" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                        Back to Portfolio
                    </div>
                </div>

                <div className="page-header mb-0">
                    <div className="page-title">Phase I</div>
                    <div className="page-subtitle">(18% Returns Per Annum)</div>
                </div>

                <div className='seeallpro-st' onClick={() => navigate("/projects")}>
                    <div className='back-btn mb-2'>
                        <h4 className='seeallpro-sttxt'>See all Projects</h4>
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#c9a84c"
                            strokeWidth="2"
                            strokeLinecap="round"
                            style={{ transform: "rotate(180deg)" }}
                        >
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </div>
                </div>
                <div className="lxp-project-grid">
                    {projectDetails?.length > 0 && projectDetails.map((item, index) => (
                        <div className="lxp-project-card" key={index}>
                            <div className="lxp-project-img">
                                <span className={`lxp-project-tag ${item?.status === 'Active' ? 'green' : (
                                    item?.status === 'Upcoming' ? 'yellow' : 'red'
                                )} `}>{item?.status}</span>
                            </div>
                            <div className="lxp-project-body">
                                <div className="lxp-project-name">{item?.property_name}</div>
                                <div className="lxp-project-loc">{item?.description}</div>
                                <div className="lxp-project-loc">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="1">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                    {item?.location}
                                </div>
                                <div className="lxp-project-meta">
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Type</div>
                                        <div className="lxp-project-meta-val">{item?.property_type}</div>
                                    </div>
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Phase</div>
                                        <div className="lxp-project-meta-val">{item?.phase}</div>
                                    </div>
                                    <div className='d-center flex-column'>
                                        <div className="lxp-project-meta-label">Inv Amount %</div>
                                        <div className="lxp-project-meta-val">{item?.interest_rate}%</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default PropertyDetail
